<template lang="pug">
div
  el-collapse(v-if="anexos.length > 0")
    el-collapse-item(v-for="(item, indexItem) in anexos" :key="indexItem" :title="formatTitle(item)")
      el-card
        el-row
          b Responsável:
          br
          span {{ item.nome_responsavel }}
        br
        el-row
          b Motivo do vínculo:
          br
          span {{ item.motivo_vinculo }}
        el-row
          listagem-documentos(
            :documentos="[item]",
            ownerDocumento="GESTAO_DOCUMENTOS"
        )
        br
        el-row
          b Data do vínculo:
          br
          span {{ formatDate(item.data_vinculo) }}
      el-card.edicao(v-if="item.data_cancelamento")
        h2 Cancelamento
        el-row
          b Responsável:
          br
          span {{ item.responsavel_cancelamento }}
        br
        el-row
          b Data do cancelamento:
          br
          span {{ getDateHour(item.data_cancelamento) }}
        br
        el-row
          b Justificativa do cancelamento:
          br
          span(v-html="item.justificativa_cancelamento")
      el-card.edicao(v-if="item.data_edicao", v-for="(log, indexCard) in item.log_edicoes" :key="indexCard")
        h2 Edição
        el-row
          b Responsável:
          br
          span {{ log.nomeUsuario }}
        br
        el-row
          b Data da edição:
          br
          span {{ getDateHour(log.data) }}
  span.center(
    v-else
  ) Nenhum documento anexado.

</template>

<script>
import { mapActions } from 'vuex'
import AppPar from '@/components/AppPar'
import moment from 'moment'
import ListagemDocumentos from '../../../../components/informacoesCadastro/ListagemDocumentos.vue'

export default {

  components: {
    AppPar,
    ListagemDocumentos
  },

  props: ['idProcesso'],

  data () {
    return {
      anexos: []
    }
  },

  async created () {
    this.anexos = await this.getAnexos(this.idProcesso)

    this.anexos.forEach(a => {
      a.log_edicoes = JSON.parse(a.log_edicoes)
    })
  },

  methods: {
    ...mapActions({
      getAnexos: 'processos/getAnexos'
    }),

    getDataDescricaoAcao (descricaoAcao) {
      return moment(descricaoAcao.substring(0, descricaoAcao.indexOf('-') - 1).trim(), 'DD/MM/YYY HH:mm:ss').toDate()
    },

    getOnlyDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    getDateHour (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },

    changeActive (stepIndex) {
      this.activeStep = stepIndex
    },

    formatTitle (item) {
      let titulo = 'Inserção de documentos'

      if (item.status === 'EDITADO') {
        titulo += ` (Editado em ${this.formatDate(item.data_edicao)})`
      } else if (item.status === 'CANCELADO') {
        titulo += ` (Cancelado em ${this.formatDate(item.data_cancelamento)})`
      }

      return titulo
    },

    formatDate (date) {
      return new Date(date).toLocaleDateString()
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.emptyHistorico {
  display: flex;
  justify-content: center;
}

.descricao {
  font-size: 13px;
}

.edicao {

}

.el-steps {
  p {
    margin: 0;
  }
  .el-step:hover {
    /deep/.el-step.is-vertical {
      .el-step__line {
        background-color: $color-primary;
        border-color: $color-primary;
      }
      .el-step__icon.is-text {
        border-color: $color-primary;
        color: $color-primary;
      }
      .el-step__icon-inner {
        color: $color-primary;
      }
      .el-step__title {
        color: $color-primary;
      }
    }

    .date-pad {
      color: $color-primary;
    }

    .circle {
      background: $color-primary;
    }
  }
}

/deep/ .el-step__icon.is-text {
  border: none;
  width: 100%;
}

/deep/ .el-step__title.is-process {
  color: $color-primary;
}

/deep/ .el-step__title.is-wait,
/deep/ .el-step__head.is-wait,
/deep/ .el-step__title.is-finish,
/deep/ .el-step__head.is-finish {
  color: black;
  border-color: black;
  opacity: 0.7;
}

/deep/ .el-step__head.is-wait,
/deep/ .el-step__head.is-finish {
  color: black;
  .el-step__line {
    background-color: black;
  }
}

/deep/ .el-step__head.is-process {
  color: $color-primary;
  font-weight: bold;
  .circle {
    background: $color-primary;
  }
  .el-step__line {
    background-color: $color-primary;
  }
  .el-step__icon.is-text {
    border-color: $color-primary;
  }
  .date-pad {
    color: $color-primary;
  }
}

/deep/ .el-step.is-vertical .el-step__line {
  left: 145px;
  margin-top: 5px;
}

/deep/ .el-step__description {
  margin-top: 10px !important;
  padding-left: 30px;
}

.inactive-step {
  flex-basis: 7% !important;
}

.active-step {
  flex-basis: unset !important;
}

/deep/ .el-step__head {
  cursor: pointer;
  width: 20% !important;
}

/deep/ .el-step__main {
  width: 80% !important;
  padding-left: 20px !important;
  padding-bottom: 10px;
  .el-step__title {
    cursor: pointer;
  }
}

/deep/ .el-collapse-item__header {
  color: rgb(112, 112, 112);
  font-size: 1em;
}

.modal {
  height: 71vh;
}

.descricao {
  font-size: 13px;
}

.steps {
  padding: 20px;
}

.painel-historico {
  max-height: 65vh;
  overflow-y: auto;
}

.btn-baixar-pdf {
  float: right;
  padding: 13px 30px;
  font-size: 15px;
  margin-top: 15px;
  margin-right: 25px;
  margin-bottom: 15px;
}
.margin-left {
  margin-left: 5px;
}

.circle {
  border: black;
  border-radius: 50%;
  background: black;
  width: 16px;
  height: 16px;
}

.date-pad {
  padding-right: 25px;
  opacity: 0.6;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

b {
  color: #424242;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarAnexosTab.vue